import { ValidationService } from '../../services/validation.service';
import { ManagementArea } from '../area-models/management-area.model';
import { LandingSite } from '../landing-site.model';
import { Subarea } from '../area-models/subarea.model';
import { customAlphabet } from 'nanoid';
const nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz-', 21);
import { SharedMethodsService } from '../../services/shared-methods.service';


export class EndReport {

  endDate: Date = new Date(); // last date fished - retrieved from the last daily catch report submitted for the trip

  managementArea: ManagementArea = new ManagementArea(); // management area specified in the last daily catch report

  subArea: Subarea = new Subarea();

  reportID: string = '';

  internalId: string = '';

  confirmationNumber: string = 'Incomplete';

  emailedAt: string = ''; // written by the backend when the report email is actually sent; suppresses duplicate sends

  completionDate: Date = new Date(); // the date the report was completed within the app

  submissionDate: Date = new Date(); // date the report was submitted to DFO (only accurate if 'isSubmitted'=true)

  comments: string = ''; // optional

  /* Arrival Details - only needed for certain trips */

  landingSite: LandingSite = new LandingSite();

  plannedOffloadDate: Date = new Date();

  /* Flags for programmatical use */

  isSubmitted: boolean = false; // flag that tells us if the report has been sent to DFO

  isComplete: boolean = false; // flag that tells us if the report has been completed

  constructor() {

    this.internalId = 'id-' + nanoid();
    this.reportID = SharedMethodsService.generateReportID("E");

  }

  public toString(): string {
    return 'End Date: ' + this.endDate + '; Confirmation Number: ' + this.confirmationNumber;
  }

  // check if the user's End Fishing Report is defined
  public static transformAnonymous(endReport: any): EndReport {

    // if it is not defined, set a new one
    if (!endReport) {
      return new EndReport();
    }

    let userEndReport: EndReport = new EndReport();
    userEndReport.internalId = endReport.internalId ?? userEndReport.internalId;
    userEndReport.endDate = ValidationService.validateDate(endReport.endDate);
    userEndReport.managementArea = ManagementArea.transformAnonymous(endReport.managementArea);
    userEndReport.confirmationNumber = endReport.confirmationNumber ?? '';
    userEndReport.emailedAt = endReport.emailedAt ?? '';
    userEndReport.completionDate = ValidationService.validateDate(endReport.completionDate);
    userEndReport.submissionDate = ValidationService.validateDate(endReport.submissionDate);
    userEndReport.comments = endReport.comments ?? '';
    userEndReport.reportID = endReport.reportID;
    userEndReport.landingSite = LandingSite.transformAnonymous(endReport.landingSite);
    userEndReport.plannedOffloadDate = ValidationService.validateDate(endReport.plannedOffloadDate);
    userEndReport.isComplete = endReport.isComplete ?? false;
    userEndReport.isSubmitted = endReport.isSubmitted ?? false;
    return userEndReport;

  }
}
